var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mall-check-box",class:{ 'mall-check-box--checked': _vm.checked && !_vm.disabled, 'mall-check-box--disabled': _vm.disabled }},[(_vm.disabled)?_c('img',{attrs:{"src":require("@/assets/mall/icn_check_line_disabled.svg"),"alt":""}}):_c('img',{attrs:{"src":require("@/assets/mall/icn_check_line_white.svg"),"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d3f38d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/new/atoms/MallCheckBox.vue
// module id = null
// module chunks = 